import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Carriers_ds_get_carrierservicetype_by_nameService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { name: string }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.name)) {
      missingRequiredInParams.push('\'name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_get_carrierservicetype_by_name/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { name: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.name)) {
      missingRequiredInParams.push('\'name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_get_carrierservicetype_by_name/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { name: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, ShortName?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.name)) {
      missingRequiredInParams.push('\'name\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Carriers/datasources/ds_get_carrierservicetype_by_name/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      name: string    }) {
        if(isNil(inParams.name)) {
          return true; 
        }
      return false;
    }
}
